import { Alert, AlertIcon, Text } from '@chakra-ui/react';
import { FC } from 'react';

export const AlertInfo: FC= ({ children }) => (
  <Alert status="info" borderRadius={3}>
    <AlertIcon />
    <Text>{ children }</Text>
  </Alert>
)
